import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'edportal-disclaimer',
  templateUrl: './disclaimer.component.html',
  styles: ``,
})
export class DisclaimerComponent {}
